import { Rubles } from 'Cloud/Application/Rubles';
import { type ReactElement, useCallback, useEffect, useRef } from 'react';

interface IProps {
    adsUpdateTimerMs: number;
    renderItem: () => ReactElement | null;
    updateAds: () => void;
    suspendTimer?: boolean;
}

export function useShowAdsBannerTimer({ adsUpdateTimerMs, renderItem, updateAds, suspendTimer = false }: IProps) {
    const adsTimer = useRef<number | undefined>();
    const updateReason = useRef<string>('start');

    const setAdsTimer = useCallback(() => {
        if (adsTimer.current) {
            window.clearTimeout(adsTimer.current);
        }

        if (document.visibilityState !== 'visible' || suspendTimer) {
            return;
        }
        Rubles.setUpdateReason(updateReason.current);
        updateAds();

        adsTimer.current = window.setTimeout(setAdsTimer, adsUpdateTimerMs);
    }, [suspendTimer, updateAds]);

    const handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
            setAdsTimer();
        }
    };

    useEffect(() => {
        setTimeout(() => {
            updateReason.current = 'start';
            setAdsTimer();
            updateReason.current = 'default';

            document.addEventListener('visibilitychange', handleVisibilityChange);
        }, 0);

        return () => {
            if (adsTimer.current) {
                window.clearTimeout(adsTimer.current);
            }
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [setAdsTimer]);

    return renderItem();
}
